import produce from 'immer';
import { IScreen, IScreenState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';
import { IScreenAction } from '../actions/screenActions';
export const initialScreenState: IScreenState = {
  screenIds: [],
  screenMap: {},
  selectedScreen: undefined,
  isFetching: false,
  selectedScreenOld: undefined
};
const processScreen = (screen: any): IScreen => {
  return {
    screenID: screen.screen_id,
    name: screen.name,
    type: screen.type,
    customers: screen.customers,
    timezone: screen.timezone
  };
};

const screenReducer = (state = initialScreenState, action: IScreenAction) => {
  const screenIds: string[] = [];
  const screenMap: { [key: string]: IScreen } = {}; // screen id to screen json map
  return produce(state, draft => {
    switch (action.type) {
      case actionTypes.FETCH_SCREENS_SUCCESS:
        draft.isFetching = false;
        action.payload.map((screen: any) => {
          screenMap[screen.screen_id] = processScreen(screen);
          screenIds.push(screen.screen_id);
        });

        draft.screenMap = { ...screenMap };
        draft.screenIds = [...screenIds];
        draft.selectedScreen =
          draft.screenIds.length > 0 ? draft.screenIds[0] : undefined;
        break;
      case actionTypes.ADD_SCREEN_SUCCESS:
        draft.screenMap[action.payload.screen_id] = processScreen(
          action.payload
        );
        draft.screenIds.push(action.payload.screen_id);
        break;
      case actionTypes.UPDATE_SCREEN_SUCCESS:
        draft.screenMap[action.payload.screen_id] = processScreen(
          action.payload
        );
        break;
      case actionTypes.FETCH_SCREENS_PENDING:
        draft.isFetching = true;
        break;
      case actionTypes.DELETE_SCREEN_SUCCESS:
        delete draft.screenMap[action.screenId];
        draft.screenIds = draft.screenIds.filter(screenId =>
          screenId === action.screenId ? false : true
        );
        if (draft.selectedScreen === action.screenId) {
          draft.selectedScreen =
            draft.screenIds.length > 0 ? draft.screenIds[0] : undefined;
        }
        break;
      case actionTypes.UPDATE_SELECTED_SCREEN:
        // set the last selected screen
        if (draft.screenIds.indexOf(action.screenId) !== -1) {
          draft.selectedScreenOld = draft.selectedScreen;
          draft.selectedScreen = action.screenId;
          localStorage.setItem('podSelectedScreen', action.screenId);
        }
        break;
    }
  });
};

export default screenReducer;
